import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Wrench } from "lucide-react";
import api from "../lib/api";
import EmployerLegalFooter from "../components/EmployerLegalFooter";

const when = (value) =>
  value
    ? new Date(value).toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : "";

export default function MaintenancePage() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api
      .get("/maintenance/status")
      .then(({ data }) => setStatus(data))
      .catch(() => setStatus({}));
  }, []);

  return (
    <div className="min-h-screen flex flex-col" data-testid="maintenance-page">
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <section
          className="w-full max-w-xl border p-7 sm:p-10"
          style={{ borderColor: "var(--border)" }}
        >
          <div
            className="mb-7 flex h-12 w-12 items-center justify-center border"
            style={{ borderColor: "var(--border-strong)", background: "var(--surface)" }}
            data-testid="maintenance-page-icon"
          >
            <Wrench size={22} style={{ color: "var(--ink)" }} />
          </div>
          {!status ? (
            <div className="flex items-center gap-2 text-sm" data-testid="maintenance-page-loading">
              <Loader2 size={16} className="animate-spin" /> Checking portal availability…
            </div>
          ) : status.active ? (
            <>
              <div className="eyebrow mb-3">Employees First Portal</div>
              <h1
                className="font-heading text-4xl font-black leading-none tracking-tight sm:text-5xl"
                style={{ color: "var(--ink)" }}
                data-testid="maintenance-page-heading"
              >
                We’ll be right back.
              </h1>
              <p
                className="mt-5 text-base leading-relaxed"
                style={{ color: "var(--muted)" }}
                data-testid="maintenance-page-message"
              >
                {status.message}
              </p>
              {status.ends_at && (
                <p
                  className="mt-4 text-sm font-semibold"
                  style={{ color: "var(--ink)" }}
                  data-testid="maintenance-page-ends-at"
                >
                  Expected to return by {when(status.ends_at)}.
                </p>
              )}
            </>
          ) : (
            <>
              <div className="eyebrow mb-3">Employees First Portal</div>
              <h1
                className="font-heading text-4xl font-black leading-none tracking-tight sm:text-5xl"
                style={{ color: "var(--ink)" }}
                data-testid="maintenance-page-available-heading"
              >
                The portal is available.
              </h1>
              <p
                className="mt-5 text-base"
                style={{ color: "var(--muted)" }}
                data-testid="maintenance-page-available-copy"
              >
                Maintenance has ended. You can return to your secure portal access now.
              </p>
              <Link
                to="/login"
                className="btn-primary mt-7 inline-flex"
                data-testid="maintenance-page-sign-in-link"
              >
                Sign in
              </Link>
            </>
          )}
        </section>
      </main>
      <EmployerLegalFooter />
    </div>
  );
}